import React, { useEffect, useState } from 'react';
import Container from '../../../../../constants/Container';
import { Grid } from '@mui/material';
import SecHeading from '../../../../../constants/SecHeading';
import SelectInputBox from '../../../../../constants/SelectInputBox';
import { GeneralLedgerOptions, ParticularOptions, SearchMemberListOptions, SubLedgerOptions, VoucherTypeOptions } from '../../../../../constants/Options';
import InputTextBox from '../../../../../constants/InputTextBox';
import EDatePicker from '../../../../../constants/EDatePicker';
import { BsCalendarDate } from 'react-icons/bs';
import { VoucherContextType } from '../../../../../context/VoucherEntryContext';
import useFetchSubData from '../../../../../helpers/useSubFetch';
import AppURL from '../../../../../constants/AppURL';
import ParticularCreateView from './dialog/ParticularCreateView';
import SubLedgerCreateView from './dialog/SubLedgerCreateView';
import { useDispatch } from 'react-redux';
import { PARTICULAR_BANK_LIST_VIEW, PARTICULAR_CASH_LIST_VIEW, SUBLEDGER_LIST_VIEW } from '../../../../../store/accountSlice';
import SelectionBox from '../../../../../constants/SelectionBox';

interface HeaderFormViewProps {
    data?: any;
    loading?: boolean;
    error?: string | null;
    context: VoucherContextType;
}

const HeaderFormView: React.FC<HeaderFormViewProps> = ({ data, loading, context, error }) => {
    const dispatch = useDispatch();
    const [onSearchMem, setOnSearchMem] = useState("")
    const handleSelect = (item: string) => {
        setOnSearchMem(item);
    };
    const { data: member_data, loading: member_loading, error: member_error } = useFetchSubData(`${AppURL.ApplicationURL}app/all/member/search/report/list/?search=${onSearchMem}`, onSearchMem);
    const searchMemberListOptions = SearchMemberListOptions(member_data?.results);
    const { values, setFieldValue, ResetForm, handleChange, handleBlur, touched, errors } = context;

    const { data: sub_ledg, loading: sub_loading, error: sub_error, refetch } = useFetchSubData(
        values.glid ? `${AppURL.AccountURL}account/general/ledger/wise/sub/options/view/?glid=${values.glid}` : '',
        values.glid
    );
    const { data: part_data, loading: part_loading, error: part_error, refetch: refetchPart } = useFetchSubData(
        values.glid ? `${AppURL.AccountURL}account/sub/ledger/wise/particular/options/view/?sglsn=${values.sglsn}` : '',
        values.sglsn
    );
    
    useEffect(() => {
        if (sub_ledg) {
            dispatch(SUBLEDGER_LIST_VIEW(sub_ledg?.data?.bank_name_list));
        }
        if (part_data) {
            dispatch(PARTICULAR_CASH_LIST_VIEW(part_data?.data?.cash_type));
            dispatch(PARTICULAR_BANK_LIST_VIEW(part_data?.data?.bank_cash_type));
        }
    }, [sub_ledg, dispatch, part_data]);

    // Generate options for General Ledger
    const generalLedgerOptions = data ? GeneralLedgerOptions(data?.data) : [];
    const subLedgerOptions = sub_ledg ? SubLedgerOptions(sub_ledg.data.sub_ledger) : [];
    const particularOptions = part_data ? ParticularOptions(part_data.data.particular) : [];
    const handleSelectBox = (name: string, selectedOption: any) => {
        const value = selectedOption ? selectedOption.value : null;
        setFieldValue(name, value);
    };
    const handleDateChange = (date: Date | null) => {
        setFieldValue('date_en', date ? date.toISOString().split('T')[0] : null);
    };
    const today = new Date();
    const [openSub, setOnSub] = useState<boolean>(false);
    const [openParticu, setOnParticu] = useState<boolean>(false);
    useEffect(()=>{
        ResetForm();
    },[]);
    
    return (
        <Container padding={true}>
            <ParticularCreateView refetch={refetchPart} particular_sn={part_data?.data?.particular_sn} particular_id={part_data?.data?.particular_id} setOnParticu={setOnParticu} openParticu={openParticu} context={context} />
            <SubLedgerCreateView data={data} setOnSub={setOnSub} refetch={refetch} account_id={sub_ledg?.data?.account_id} sub_account_sn={sub_ledg?.data?.sub_account_sn} openSub={openSub} context={context} />
            <SecHeading type='add' label='Voucher Entry' />
            <Grid container spacing={1}>
                <Grid item lg={3} md={3} xs={12} xl={3} sm={6}>
                    <EDatePicker
                        maxDate={today}
                        selected={values.date_en ? new Date(values.date_en) : null}
                        handleChange={handleDateChange}
                        required
                        label='Date(AD)'
                    />
                </Grid>
               
                <Grid item lg={3} md={3} xs={12} xl={3} sm={6}>
                    <InputTextBox
                        type='text'
                        prefix={<BsCalendarDate />}
                        handleChange={(e) => handleSelectBox('fiscal_year_date', e.target.value)}
                        label='Fiscal Year'
                        name='fiscal_year_date'
                        handleBlur={handleBlur}
                        value={values.fiscal_year_date}
                        touched={touched.fiscal_year_date}
                        placeholder='Fiscal Year'
                        disabled
                        required={true}
                    />
                </Grid>
                <Grid item lg={3} md={3} xs={12} xl={3} sm={6}>
                    <SelectInputBox
                        label='Voucher Type'
                        options={VoucherTypeOptions}
                        optionSelect={(name, selectedOption) => {
                            handleSelectBox(name, selectedOption);
                        }}
                        isLoading={false}
                        value={values.voucher_type}
                        required={true}
                        placeholder='Select Voucher Type'
                        name='voucher_type'
                        handleBlur={handleBlur}
                        touched={touched.voucher_type}
                        errors={errors.voucher_type}
                    />
                </Grid>
                <Grid item lg={3} md={3} xs={12} xl={3} sm={6}>
                    <SelectionBox
                        label='General Ledger'
                        options={generalLedgerOptions}
                        handleChange={(name, selectedOption: any) => {
                            setFieldValue('particularid', '');
                            setFieldValue('member_sn', '');
                            setFieldValue(name, selectedOption?.value);
                        }}
                        isLoading={loading}
                        value={values.glid}
                        required={true}
                        placeholder='Select General Ledger'
                        name='glid'
                        handleBlur={handleBlur}
                        touched={touched.glid}
                        errors={errors.glid}
                    />
                </Grid>
                <Grid item lg={3} md={3} xs={12} xl={3} sm={6}>
                    <SelectionBox
                        label='Sub Ledger'
                        handleChange={(name, selectedOption: any) => {
                            setFieldValue("mem_cate_id", selectedOption.mem_cate_id);
                            setFieldValue('member_sn', '');
                            setFieldValue(name, selectedOption?.value);
                        }}
                        name='sglsn'
                        view_click={()=>setFieldValue('view_full_leader', !values.view_full_leader)}
                        view_title='View Ledger'
                        onClick={() => setOnSub(true)}
                        isLoading={sub_loading}
                        add_btn={values.glid ? true : false}
                        options={subLedgerOptions}
                        value={values.sglsn}
                        errors={errors.sglsn}
                        touched={touched.sglsn}
                        required={true}
                        placeholder='Select Sub Ledger'
                    />
                </Grid>
                {
                    values.mem_cate_id === 1 &&  <Grid item lg={3} md={3} xs={12} xl={3} sm={6}>
                    <SelectInputBox
                        label='Member List'
                        options={searchMemberListOptions}
                        optionSelect={(name, selectedOption) => {
                            handleSelectBox(name, selectedOption);
                        }}
                        isLoading={false}
                        value={values.member_sn}
                        required={true}
                        placeholder='Select Member List'
                        name='member_sn'
                        clear
                        handleBlur={handleBlur}
                        debouncedHandleInputChange={handleSelect}
                        touched={touched.member_sn}
                        errors={errors.member_sn}
                    />
                </Grid>
                }
               
                <Grid item lg={3} md={3} xs={12} xl={3} sm={6}>
                    <SelectInputBox
                        label='Particular'
                        optionSelect={(name, selectedOption) => {
                            setFieldValue("is_debit", selectedOption.is_debit);
                            setFieldValue("particular_name", selectedOption.label);
                            handleSelectBox(name, selectedOption);
                        }}
                        add_btn={values.sglsn ? true : false}
                        onClick={() => setOnParticu(true)}
                        options={particularOptions}
                        value={values.particularid}
                        isLoading={part_loading}
                        required={true}
                        placeholder='Select Particular'
                        name='particularid'
                        errors={errors.particularid}
                        touched={touched.particularid}
                    />
                </Grid>
            </Grid>
        </Container>
    );
}

export default HeaderFormView;
